function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import iconTheme from '../../Icon/Icon.theme';
export var base = _objectSpread({
  grid: {
    /**
     * The following breakpoints are being used by media query mixin
     * to generate media queries to cover all resolutions.
     * As such, these properties must be in exactly this order, i.e.
     * from xs to xl. Otherwise the generated media queries do NOT work
     * as they wouldn't be applied in the correct order.
     */
    breakpoints: {
      xs: '575px',
      // 0px - 575px
      sm: '576px',
      // 576px - 767px
      md: '768px',
      // 768px - 991px
      lg: '992px',
      // 992px - 1327px
      xl: '1328px' // 1328px - infinite

    },
    container: {
      padding: '0',
      maxWidth: '1248px' // The grid does NOT go wider than this width

    }
  },
  badge: {
    colors: {
      danger: '#f3cbcb',
      info: '#d8dcde',
      warning: '#fbdfcf',
      success: '#d6e7d9',
      neutralDefault: '#b3b3b3',
      neutralDark: '#000000',
      neutralWhite: '#fff'
    }
  },
  darkenPercentage: {
    hover: 0.1
  },
  radius: '4px',
  modalRadius: '8px',
  // todo: refactor radius to be more specific about where its used, e.g. radius: { modal: 8px, input: 4px, standard: 4px }
  zIndex: {
    dropdown: '1000',
    sticky: '1020',
    fixed: '1030',
    modalBackdrop: '1040',
    modal: '1050',
    datepicker: '1055',
    popover: '1060',
    tooltip: '1070',
    pageSpinner: '1080'
  }
}, iconTheme);